<template>
  <div class="ui-pannel">
    <p class="title">{{$t("myStudent")}}</p>
    <div class="content">
      <ul class="tabs">
        
        <li :class="{on: info.courseState === 0}" @click="changeTab(0)"><!-- 全部 -->All</li>
        <li :class="{on: info.courseState === 1}" @click="changeTab(1)"><!-- 课程已预约 -->Lessons booked</li>
        <li :class="{on: info.courseState === 2}" @click="changeTab(2)"><!-- 课程已完结 -->Lessons completed</li>
      </ul>
      <div class="ui-empty" v-if="students.length === 0">
        <!-- No data -->
      </div>
      <div class="list" v-else>
        <div class="cell" v-for="(item, index) in students" :key="index">
          <div class="card">
            <div class="avatar" @click="goDetail(item.studentId)">
              <img :src="item.studentPhoto" alt="" style="object-fit: cover;">
              <span class="detail">Detail</span>
            </div>
            <p class="info">
              <span class="txt">{{item.studentName}}</span>
            </p>
            <p class="desc">
              <span class="txt">{{item.stateName}}</span>
              <span class="txt"> {{item.courseCount}} {{$t("common.lessons")}}</span>
            </p>
            <!-- <router-link :to="{path: '/user/invite', query: {id: item.studentId, name: item.studentName}}" class="ui-btn">{{$t("user.invite")}}</router-link> -->
          </div>
        </div>
        <template v-if="students.length > 4">
          <hr v-for="n in (Math.ceil(students.length / 4) - 1)" :key="n" :style="{top: 340 * n + 'px'}">
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import {getMyStudentList} from '@/service/teacherApi.js'
export default {
  data(){
    return {
      students: [],
      info: {
        pageSize: 10,
        pageNO: 1,
        totalCount: 0,
        courseState: 0
      }
    }
  },
  mounted(){
    this.getMyStudentList()
  },
  methods: {
    changeTab(n){
      if(this.info.courseState !== n){
        this.info.courseState = n
        this.getMyStudentList()
      }
    },
    goDetail(id){
      this.$router.push({path: '/studentDetail', query: {id: id}})
    },
    async getMyStudentList(){
      let res = await getMyStudentList(this.info)
      if(res.data.status === 1){
        this.students = res.data.data
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.content{padding: 30px 50px 20px;}
.tabs{
  display: flex;
  li{
    margin-right: 10px; width: 180px; height: 42px; line-height: 42px; border-radius: 12px 12px 0 0; text-align: center; background: #A9C4B1; color: #fff; cursor: pointer;
    &.on{background: #002147;}
  }
}
.list{
  position: relative; display: flex; flex-wrap: wrap; margin-right: -20px;
  .cell{padding: 50px 0; text-align: center; margin-right: 20px;}
  .card{
    width: 192.5px; min-height: 240px; background: #FBFBFB; border-radius: 5px; padding: 45px 10px 20px; cursor: pointer; transition: all .3s;
    &:hover{background: #fff; box-shadow: 0 3px 21px rgba($color: #7B7B7B, $alpha: .16);}
  }
  .avatar{
    margin: 0 auto; width: 90px; height: 90px; border-radius: 50%; font-size: 0; overflow: hidden; position: relative;
    &:hover .detail{display: block;}
  }
  img{width: 100%; height: 100%;}
  .info{font-size: 14px; line-height: 21px; margin-top: 20px;}
  .desc{color: #999; line-height: 19px;margin-top: 10px;}
  // .txt{margin: 0 5px;}
  hr{position: absolute; left: 0; right: 20px; border: 1px dashed #707070; top: 340px;}
  .ui-btn{margin: 20px 0;}
  .detail{position: absolute; bottom: 0; left: 0; right: 0; height: 35px; line-height: 35px; text-align: center; color: #fff; background: rgba($color: #2680eb, $alpha: .55); font-size: 14px; display: none;}
}
</style>
<i18n>
{
  "cn": {
    "myStudent": "我的学生"
  },
  "TW": {
    "myStudent": "我的學生"
  },
  "en": {
    "myStudent": "My Students"
  }
}
</i18n>